<p>
    <a [href]="other" class="manualLink">{{title}}</a>
    <span *ngIf="description !== ''">&nbsp;-&nbsp;{{description}}</span>
</p>
